import { SignIn } from '@/containers/signin';
import { useGo } from '@/lib/useGo';

export default function SignInRoute() {
  const go = useGo();
  return <SignIn go={go} />;
}
